/** Decode JWT payload for local UI display only — not for security decisions. */

export type DecodedJwtProfile = {
  sub?: string;
  email?: string;
  preferred_username?: string;
  name?: string;
  tenant_id?: string;
  realm_access?: { roles?: string[] };
  resource_access?: Record<string, { roles?: string[] }>;
};

export function decodeJwtPayload(token: string): DecodedJwtProfile | null {
  const parts = token.split('.');
  if (parts.length < 2) return null;
  try {
    const json = atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(json) as DecodedJwtProfile;
  } catch {
    return null;
  }
}

export function profileDisplayName(profile: DecodedJwtProfile | null): string {
  if (!profile) return '';
  return (
    profile.preferred_username ||
    profile.email ||
    profile.name ||
    profile.sub ||
    ''
  ).trim();
}

export function profileRoles(profile: DecodedJwtProfile | null): string[] {
  if (!profile) return [];
  const realm = profile.realm_access?.roles ?? [];
  const resource = Object.values(profile.resource_access ?? {}).flatMap((r) => r.roles ?? []);
  return [...new Set([...realm, ...resource])].filter(Boolean);
}
